import React, { useCallback, useEffect, useState } from 'react'

import './teamSection.css'
import Slider from "react-slick";
import TeamItem from './TeamItem'
import { message } from 'antd';
import {motion} from 'framer-motion'
import {Link} from 'react-router-dom'

function SampleNextArrow(props) {
  const { onClick } = props;
  return <div className="custom-next-arrow" onClick={onClick} />;
}

function SamplePrevArrow(props) {
  const { onClick } = props;
  return <div className="custom-prev-arrow" onClick={onClick} />;
}

const TeamSection = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const [data, setdata] = useState([[]])
  const fetchManager = useCallback(async () => {
    try {
      const response = await fetch(`${apiUrl}/api/manager`)

      if (response.ok) {
        const data1 = await response.json()
        setdata(data1)
      } else {
        message.error("Server Hatası : Kullanıcılar Getirilemedi")
      }
    } catch (error) {
      console.log(error);
    }
  }, [apiUrl])

  useEffect(() => {
    fetchManager()
  }, [fetchManager])




var settings = {
    
  
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  nextArrow: <SampleNextArrow />,
  prevArrow: <SamplePrevArrow />,
    responsive: [
        {
          breakpoint: 1224,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            initialSlide: 2
          }
        },
        
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]

    
  };
  return (
    <>
    <motion.div 
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      viewport={{ once: true, amount: 0.3 }}
      className="team-section">
        <div className="team-section-title">
            <h2>Yönetim Kadrosu</h2>
        </div>

        
        <div className="slider-container">
        <Slider autoplay speed={500} {...settings}>
        {
            data.map((item,key) => (
              
             <TeamItem key={key} item={item} />
            ))
        }
     </Slider>

</div>

        <div className="team-more">
            <p>Yönetim ekibinin tamamını görmek için lütfen <Link to="/yonetim" ><b>tıklayınız</b>.</Link></p>
        </div>
  </motion.div>
  
  
  </>
  )
}

export default TeamSection